//Turns files into base64 in order to be handled as blob by database
export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

//Creating an object that explains the action type in readable user friendly format
export const createSelectionTypeObject = (selectionTypes, onlyUpperCase = false) => {
  let selectionTypeArray = [];
  for (let selectionType of selectionTypes) {
    let selectionTypeText = !onlyUpperCase ? selectionType.charAt(0).toUpperCase() + selectionType.substring(1).toLowerCase() : selectionType.toUpperCase();
    selectionTypeText = selectionTypeText.replaceAll('_', ' ');
    selectionTypeArray.push({
      value: selectionType,
      text: selectionTypeText,
    });
  }
  return selectionTypeArray;
};

export const OWNER_LEVEL = ['LOCAL', 'VENDOR'];

export const LANGUAGES = [
  {
    name: 'English',
    code: 'en',
  },
  {
    name: 'Norwegian',
    code: 'no',
  },
];
